module.exports = __webpack_public_path__ + "img/loginBg.b8eb0e4a.png";